import { useCallback, useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';
import InfiniteScroll from 'modules/shared/components/general/InfiniteScroll/InfiniteScroll';

import BrandCard from 'modules/ClientCommunication/components/BrandCard';
import Spinner from 'modules/shared/components/general/Spinner/Spinner';
import Flex from 'modules/shared/components/general/Flex/Flex';

import { getMonthlyUpdateBrandsLogos } from 'services/reporting.services';
import { servicesNames } from 'constants/servicesNames.constants';

import { getPageFromUrl } from 'helpers/PageFromUrl';

import alien_gray from "assets/icons/alien-gray.svg";

import './styles.scss';

export default function MonthlyStrategyUpdate() {
  const {
    data: brandsLogos,
    fetchNextPage,
    isLoading,
    isFetchingNextPage,
  } =
        useInfiniteQuery(
          [servicesNames.getMonthlyUpdateBrands],
          ({ pageParam = 1 }) => getMonthlyUpdateBrandsLogos(pageParam),
          {
            getNextPageParam: ({ data: { next = '' } = {} }) => {
              if (next) {
                const res = getPageFromUrl(next);
                return res ? Number(res) : undefined;
              }
            },
          },
        );


  const brands = useMemo(() => brandsLogos?.pages.flatMap(({ data }) => data.results) ?? [], [brandsLogos]);
  const total = useMemo(() => brandsLogos?.pages[0].data.count ?? 0, [brandsLogos]);

  const renderBrandsContent = useCallback(() => {
    if (isLoading) {
      return (
        <Flex style={{ width: '100%', height: '100%', paddingTop: 150 }} justifyContent="center" alignItems="center">
          <Spinner />
        </Flex>
      );
    }

    if (!brands.length) {
      return (
        <Flex style={{ width: '100%', height: '100%', paddingTop: 150 }} direction="column" justifyContent="center" alignItems="center" gap="16px">
          <img src={alien_gray} alt="not found brands" />
          <span className="brands-not-found">No strategy emails available.</span>
        </Flex>
      );
    }
    return (
      <div className="brands-container">
        {brands.map(brand => <BrandCard key={brand.id} brand={brand} />,
        )}
        {isFetchingNextPage && (
          <Flex style={{ width: '100%' }} justifyContent="center">
            <Spinner />
          </Flex>
        )}
      </div>
    );
  }, [brands, isLoading, isFetchingNextPage]);
    
  return (
    <InfiniteScroll
      scroll
      next={() => fetchNextPage()}
      maxHeight={'calc(100vh - 100px)'}
      hasMore={brands.length < total}
    >
      <div className="monthly-strategy-update-container">
        <div className="monthly-strategy-update-container-header">
          <h1 className="monthly-strategy-update-container-header-title">Monthly Strategy Update</h1>
          {brands.length > 0 && (
            <h5 className="monthly-strategy-update-container-header-subtitle">Choose a brand</h5>
          )}
        </div>
        {renderBrandsContent()}
      </div>
    </InfiniteScroll>
  );
}
